<script>
	import { onMount, onDestroy } from "svelte";

	import { Col, Row } from "@sveltestrap/sveltestrap";
	import FilterForm from "../../../../../components/FilterForm/FilterForm.svelte";
	import PageHeader from "../../../../../components/PageHeader/PageHeader.svelte";
	import SizeSelect from "../../../../../components/SizeSelect/SizeSelect.svelte";
	import MainIssueTable from "./MainIssueTable.svelte";
	import queryString from "query-string";
	import ErrorMessageHandler from "../../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import client from "src/services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
	} from "../../../../../store/store";
	import { get } from "svelte/store";
	import { navigate } from "svelte-routing";

	let data = [];
	const query = queryString.parse(window.location.search);
	let searchParams = new URLSearchParams(window.location.search);
	onMount(async () => {
		document.body.scrollIntoView();
		try {
			loading.set(true);
			const res = await client(
				"/v0/Issue/v2/GetReportedIssuesWithFilter",
				{
					method: "POST",
					version: "Tasking",
					data: {
						status: !query.status ? [] : [+query.status],
						reportSection: !query.reportSection
							? []
							: [query.reportSection],
						carSection: !query.carSection ? [] : [query.carSection],
						damageType: !query.damageType ? [] : [query.damageType],
						vehicleNumber: !query.vehicleNumber
							? ""
							: query.vehicleNumber.trim(),
						limit: get(sizeSelect),
						page: query.page,
					},
				}
			);
			data = res.data.data.issues;

			totalPages.set(res.data.data.totalPages);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);

			console.log(err.response);
			errorMessage.set(err.response.data.errors[""]["0"]);
		}
	});
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	const trigerSelectIssue = async () => {
		try {
			loading.set(true);
			const res = await client(
				"/v0/Issue/v2/GetReportedIssuesWithFilter",
				{
					method: "POST",
					version: "Tasking",
					data: {
						status: !query.status ? [] : [+query.status],
						reportSection: !query.reportSection
							? []
							: [query.reportSection],
						carSection: !query.carSection ? [] : [query.carSection],
						damageType: !query.damageType ? [] : [query.damageType],
						vehicleNumber: !query.vehicleNumber
							? ""
							: query.vehicleNumber.trim(),
						limit: get(sizeSelect),
						page: query.page,
					},
				}
			);
			data = res.data.data.issues;

			const beforeFilterTotalPages = $totalPages;
			totalPages.set(res.data.data.totalPages);
			const afterFilterTotalPages = $totalPages;
			const currentPage = searchParams.get("page");

			if (
				afterFilterTotalPages < beforeFilterTotalPages &&
				currentPage > afterFilterTotalPages
			) {
				searchParams.set("page", 1);
				var newRelativePathQuery =
					window.location.pathname + "?" + searchParams.toString();
				navigate(newRelativePathQuery);
				window.location.reload();
			} else {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			console.log(err);

			console.log(err.response);
			errorMessage.set(err.response.data.errors[""]["0"]);
		}
	};

	onDestroy(() => {
		initPage.set(1);
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Pending Issues" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm
						carSection
						reportSection
						damageType
						vehicleNumber
						reportStatus
					/>
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div class="d-flex align-items-center">
						<SizeSelect trigerSelect={trigerSelectIssue} />
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<MainIssueTable {data} />
	</Col>
</Row>
